import React from 'react';
import AffiliationsTooltip from 'app/blocks/article-affiliations-editor/article-affiliations-panel/ConfirmPriceChange/AffiliationsTooltip/AffiliationsTooltip';
import { PriceChangeType } from 'app/blocks/article-affiliations-editor/types';

type FundingInfoConfig = {
    readonly icon: 'institution' | 'money' | 'creditCard';
    readonly label: string;
    readonly seleniumid: string;
    readonly value: React.ReactNode;
};

type FundingConfigsProps = {
    readonly priceChangeType: PriceChangeType;
    readonly primaryInstitutionName?: string;
    readonly affiliationValue: React.ReactNode;
    readonly l: l;
    readonly seleniumid: string;
    readonly rejectionReasonAccountBalanceNotEnough?: boolean;
};

export function getFundingInfoConfigs({
    affiliationValue,
    l,
    priceChangeType,
    primaryInstitutionName,
    rejectionReasonAccountBalanceNotEnough,
    seleniumid,
}: FundingConfigsProps): FundingInfoConfig[] {
    if (priceChangeType === PriceChangeType.AUTHOR_TO_FUNDER || priceChangeType === PriceChangeType.FUNDER_TO_FUNDER) {
        return [
            {
                icon: 'institution',
                label: l('ARTICLE_AFFILIATION_EDITOR.CONFIRM_PRICE_CHANGE_PRIMARY_AFFILIATION'),
                seleniumid: `${seleniumid}-institution-name`,
                value: primaryInstitutionName || '',
            },
            {
                icon: 'money',
                label: l('ARTICLE_AFFILIATION_EDITOR.CONFIRM_PRICE_CHANGE_FUNDING_AVAILABILITY'),
                seleniumid: `${seleniumid}-funding-availability`,
                value: l('ARTICLE_AFFILIATION_EDITOR.CONFIRM_PRICE_CHANGE_FUNDING_TYPE'),
            },
        ];
    }
    if (priceChangeType === PriceChangeType.FUNDER_TO_AUTHOR) {
        let fundingAvailabilityValue: string;

        if (rejectionReasonAccountBalanceNotEnough) {
            fundingAvailabilityValue = l(
                'ARTICLE_AFFILIATION_EDITOR.CONFIRM_PRICE_CHANGE_FUNDING_REJECTION_REASON_ACCOUNT_BALANCE_NOT_ENOUGH',
            );
        } else {
            fundingAvailabilityValue = l('ARTICLE_AFFILIATION_EDITOR.CONFIRM_PRICE_CHANGE_FUNDING_NO_COVERAGE');
        }

        return [
            {
                icon: 'institution',
                label:
                    React.isValidElement(affiliationValue) && affiliationValue.type === AffiliationsTooltip
                        ? l('ARTICLE_AFFILIATION_EDITOR.CONFIRM_PRICE_CHANGE_AFFILIATIONS_TITLE')
                        : l('ARTICLE_AFFILIATION_EDITOR.CONFIRM_PRICE_CHANGE_AFFILIATION_TITLE'),
                seleniumid: `${seleniumid}-institution-name`,
                value: affiliationValue,
            },
            {
                icon: 'money',
                label: l('ARTICLE_AFFILIATION_EDITOR.CONFIRM_PRICE_CHANGE_FUNDING_AVAILABILITY'),
                seleniumid: `${seleniumid}-funding-availability`,
                value: fundingAvailabilityValue,
            },
            {
                icon: 'creditCard',
                label: l('ARTICLE_AFFILIATION_EDITOR.CONFIRM_PRICE_CHANGE_RESPONSIBLE_FOR_PAYMENT'),
                seleniumid: `${seleniumid}-apc-responsibility`,
                value: l('ARTICLE_AFFILIATION_EDITOR.CONFIRM_PRICE_CHANGE_AUTHOR'),
            },
        ];
    }
    if (priceChangeType === PriceChangeType.FUNDER_TO_AUTHOR_INSTITUTIONAL_DISCOUNT) {
        return [
            {
                icon: 'institution',
                label:
                    React.isValidElement(affiliationValue) && affiliationValue.type === AffiliationsTooltip
                        ? l('ARTICLE_AFFILIATION_EDITOR.CONFIRM_PRICE_CHANGE_AFFILIATIONS_TITLE')
                        : l('ARTICLE_AFFILIATION_EDITOR.CONFIRM_PRICE_CHANGE_AFFILIATION_TITLE'),
                seleniumid: `${seleniumid}-institution-name`,
                value: affiliationValue,
            },
            {
                icon: 'money',
                label: l('ARTICLE_AFFILIATION_EDITOR.CONFIRM_PRICE_CHANGE_FUNDING_AVAILABILITY'),
                seleniumid: `${seleniumid}-funding-availability`,
                value: l('ARTICLE_AFFILIATION_EDITOR.CONFIRM_PRICE_CHANGE_FUNDING_PARTIAL_COVERAGE'),
            },
            {
                icon: 'creditCard',
                label: l('ARTICLE_AFFILIATION_EDITOR.CONFIRM_PRICE_CHANGE_RESPONSIBLE_FOR_PAYMENT'),
                seleniumid: `${seleniumid}-apc-responsibility`,
                value: l('ARTICLE_AFFILIATION_EDITOR.CONFIRM_PRICE_CHANGE_AUTHOR_WITH_DISCOUNT'),
            },
        ];
    }
    if (priceChangeType === PriceChangeType.AUTHOR_TO_AUTHOR_INSTITUTIONAL_DISCOUNT) {
        return [
            {
                icon: 'institution',
                label:
                    React.isValidElement(affiliationValue) && affiliationValue.type === AffiliationsTooltip
                        ? l('ARTICLE_AFFILIATION_EDITOR.CONFIRM_PRICE_CHANGE_AFFILIATIONS_TITLE')
                        : l('ARTICLE_AFFILIATION_EDITOR.CONFIRM_PRICE_CHANGE_AFFILIATION_TITLE'),
                seleniumid: `${seleniumid}-institution-name`,
                value: affiliationValue,
            },
            {
                icon: 'money',
                label: l('ARTICLE_AFFILIATION_EDITOR.CONFIRM_PRICE_CHANGE_FUNDING_AVAILABILITY'),
                seleniumid: `${seleniumid}-funding-availability`,
                value: l('ARTICLE_AFFILIATION_EDITOR.CONFIRM_PRICE_CHANGE_FUNDING_PARTIAL_COVERAGE'),
            },
            {
                icon: 'creditCard',
                label: l('ARTICLE_AFFILIATION_EDITOR.CONFIRM_PRICE_CHANGE_RESPONSIBLE_FOR_PAYMENT'),
                seleniumid: `${seleniumid}-apc-responsibility`,
                value: l('ARTICLE_AFFILIATION_EDITOR.CONFIRM_PRICE_CHANGE_AUTHOR_WITH_DISCOUNT'),
            },
        ];
    }
    return null;
}
